import type { Dictionary } from '../i18n.js';

export const account: Dictionary = {
  // account.ts
  'That did not work. Try again.': 'Nie udało się. Spróbuj ponownie.',
  'Who is driving?': 'Kto za kierownicą?',
  'Your driver': 'Twój kierowca',
  'Driver name': 'Imię kierowcy',
  'Car colour': 'Kolor auta',
  'Account — optional': 'Konto — opcjonalne',
  'Set your name': 'Wpisz swoje imię',
  'Driving as {name}, signed in — your races are recorded': 'Jeździsz jako {name} · zalogowano — twoje wyścigi są zapisywane',
  'Your name, your car colour, and an optional account': 'Twoje imię, kolor auta i opcjonalne konto',
  'This is your account name, so it is the same on the grid and on the leaderboard.':
    'To nazwa twojego konta, więc na starcie i w rankingu wygląda tak samo.',
  'Passkeys need a secure connection, so signing in only works on localhost or over https. You can still race and join any lobby from here — an account is only needed to build your own tours.':
    'Klucze dostępu wymagają bezpiecznego połączenia, więc logowanie działa tylko na localhost albo przez https. Stąd też możesz się ścigać i dołączyć do dowolnego lobby — konto przydaje się tylko do tworzenia własnych turniejów.',
  'Racing never needs one. An account keeps your record and lets you build tours, under the driver name above. No password and no e-mail: your device holds the key and asks you for a fingerprint, face or PIN.':
    'Do ścigania się nigdy nie jest potrzebne. Konto przechowuje twoje wyniki i pozwala tworzyć turnieje — pod imieniem kierowcy wpisanym wyżej. Bez hasła i bez e-maila: klucz trzyma twoje urządzenie, a ono prosi o odcisk palca, twarz albo PIN.',
  'Create an account': 'Załóż konto',
  'Pick a driver name first — the account is made under it.': 'Najpierw wpisz imię kierowcy — konto zostanie założone pod nim.',
  or: 'lub',
  'Sign in with a passkey': 'Zaloguj się kluczem dostępu',
  'Remove {label}': 'Usuń klucz {label}',
  'used {when}': 'użyty {when}',
  'added {when}': 'dodany {when}',
  'Signed in as ': 'Zalogowano jako ',
  'Any of these will sign you in.': 'Zalogujesz się dowolnym z nich.',
  'Add a second passkey on another device — if you lose this one, there is no other way back in.':
    'Dodaj drugi klucz dostępu na innym urządzeniu — jeśli stracisz ten, nie będzie innej drogi powrotu do konta.',
  'Add a passkey': 'Dodaj klucz dostępu',
  'Car colour {hex}': 'Kolor auta {hex}',
  'See the global board': 'Zobacz ranking ogólny',
  'No races on record yet. Anything you race while signed in counts — points, wins and your best time in each region, and a place on the global board.':
    'Nie masz jeszcze zapisanych wyścigów. Liczy się wszystko, co przejedziesz po zalogowaniu — punkty, wygrane, najlepszy czas w każdym obszarze i miejsce w rankingu ogólnym.',
  Points: 'Punkty',
  'Cup points, awarded for single races too': 'Punkty pucharowe, przyznawane też za pojedyncze wyścigi',
  Wins: 'Wygrane',
  Podiums: 'Podia',
  'Top three in a field of at least three': 'Miejsce w pierwszej trójce, gdy startuje co najmniej trzech kierowców',
  Races: 'Wyścigi',
  'Cups won': 'Wygrane puchary',
  Finished: 'Ukończone',
  Distance: 'Dystans',
  'Time driven': 'Czas za kierownicą',
  'Best times': 'Najlepsze czasy',
  Passkey: 'Klucz dostępu',
  'Cancelled.': 'Anulowano.',
  'This device already has a passkey for this account.': 'To urządzenie ma już klucz dostępu do tego konta.',

  // audioSettings.ts
  Off: 'Brak',
  Soundtrack: 'Soundtrack',
  File: 'Plik',
  Play: 'Odtwórz',
  'Mute everything': 'Wycisz wszystko',
  Music: 'Muzyka',
  Volume: 'Głośność',
  'The soundtrack plays during races. Or bring your own file, or paste a link.':
    'Soundtrack gra w trakcie wyścigów. Możesz też wczytać własny plik albo wkleić link.',
  'No soundtrack is installed — bring your own file, or paste a link.':
    'Nie ma zainstalowanego soundtracku — wczytaj własny plik albo wklej link.',
  'No music.': 'Bez muzyki.',
  'Soundtrack ready: {label} — starts with the race.': 'Soundtrack gotowy: {label} — ruszy razem z wyścigiem.',
  'Playing: {label}': 'Odtwarzanie: {label}',
  'Loading: {label}': 'Wczytywanie: {label}',

  // graphicsSettings.ts
  Graphics: 'Grafika',
  Quality: 'Jakość',
  High: 'Wysoka',
  Low: 'Niska',
  'Chase camera': 'Kamera za autem',
  Above: 'Z góry',
  'Low and close': 'Nisko i blisko',
  'Draw distance': 'Zasięg widzenia',
  Near: 'Blisko',
  Medium: 'Średnio',
  Everything: 'Wszystko',
  'A big region is smoother drawn nearer: the city fades into the haze instead. The view from above always sees all of it.':
    'Duży obszar działa płynniej z bliższym zasięgiem: miasto znika wtedy w mgiełce. Widok z góry zawsze pokazuje całość.',
  'Every frame is graded and the sun glares. Drop to Low if the race stutters.':
    'Każda klatka przechodzi korekcję, a słońce oślepia. Przełącz na Niską, jeśli wyścig się tnie.',
  'Fewer pixels, no reflections and no glow. For phones and older laptops.':
    'Mniej pikseli, bez odbić i bez poświaty. Dla telefonów i starszych laptopów.',
  'Graphics dropped to Low to keep the race smooth. Esc to change it.':
    'Grafika przełączona na Niską, żeby wyścig był płynny. Zmienisz to pod Esc.',

  // music.ts
  'Track {n}': 'Utwór {n}',
  'No soundtrack is installed on this server.': 'Na tym serwerze nie ma soundtracku.',
  'The soundtrack would not start. Press play in the audio settings.':
    'Soundtrack nie chce ruszyć. Włącz go w ustawieniach dźwięku.',
  'Could not play that file — the browser may not support its format.':
    'Nie da się odtworzyć tego pliku — przeglądarka może nie obsługiwać jego formatu.',
  'Could not read that file.': 'Nie da się odczytać tego pliku.',
  'That URL would not play — check it allows cross-site playback.':
    'Nie da się odtworzyć tego adresu — sprawdź, czy pozwala na odtwarzanie z innych stron.',
  'Could not load that URL.': 'Nie da się wczytać tego adresu.',
  'That track would not play.': 'Nie da się odtworzyć tego utworu.',

  // dom.ts
  '{n}st': '{n}.',
  '{n}nd': '{n}.',
  '{n}rd': '{n}.',
  '{n}th': '{n}.',
  '{s}s': '{s} s',
  '{m}m': '{m} min',
  '{h}h {m}m': '{h} h {m} min',
  today: 'dzisiaj',
  yesterday: 'wczoraj',
  '{n} days ago': { one: '{n} dzień temu', few: '{n} dni temu', many: '{n} dni temu' },

  // net.ts
  'retrying in {seconds}s': 'ponowna próba za {seconds} s',

  // game.ts
  'This region is {triangles} triangles, over the {budget} budget. Expect frame drops on a laptop.':
    'Liczba trójkątów w tym obszarze ({triangles}) przekracza budżet {budget}. Na laptopie gra może się przycinać.',
  'Running at ~{fps} fps with {triangles} triangles. Try a smaller region.':
    'Gra chodzi w ~{fps} fps przy {triangles} trójkątach. Spróbuj mniejszego obszaru.',
};
